export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-20 py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading mb-5">关于每日大瓜</h2>
          <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4">
            <p>
              每日大瓜诞生于对真实娱乐资讯的执着追求。我们厌倦了千篇一律的通稿和删帖控评的粉圈生态，决心打造一个独立、硬核、不妥协的黑料深扒平台。
            </p>
            <p>
              团队由资深娱乐记者、数据分析师和深度调查人员组成，秉持「不编造、不美化、不删除」三不原则，对每一条爆料进行多源交叉验证后再发布。我们的内容覆盖娱乐圈、网红圈、直播圈、选秀圈以及跨界联动事件，从时间线梳理到人物关系图谱，力求为读者呈现最完整的事件全貌。
            </p>
            <p>
              每日大瓜不仅是一个黑料网站，更是一个吃瓜爱好者的聚集地。我们欢迎理性的讨论、有据的质疑和真诚的投稿，但拒绝网络暴力和人身攻击。在这里，真相比立场更重要。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}